<script>
import { list } from '@/api/acessomodulo'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ descricao: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="descricao"
    width="1000"
    component="app-acessomodulo-grid"
    label="Acesso Módulo"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
